import { BaseModel } from './base-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';
import BlockModel from './block-model.interface';

export interface CounterModel extends BaseModel {
  variables?: { [key: string]: string } | CounterVariables;
}

export interface CounterVariables {
  CountdownLink: string;
  CountdownImage: string;
  CountdownAlt: string;
  CountdownLinkSegmentRegex: string;
}

export class CounterInitVariables implements CounterVariables {
  CountdownImage = '';
  CountdownLink = '';
  CountdownAlt = '';
  CountdownLinkSegmentRegex = '';
}

export class CounterInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new CounterInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
